import React from 'react';
import { Row } from 'react-table';

import { Appointment } from '@work4all/models/lib/Classes/Appointment.entity';

import { BillableApppointmentIcon } from '../../../../components/billable-appointment-icon/BillableApppointmentIcon';

export type IBillableStatusCellProps = {
  row: Row<Appointment>;
};

export const BillableStatusCell: React.FC<IBillableStatusCellProps> = ({
  row: { original: rowData },
}) => {
  return <BillableApppointmentIcon appointment={rowData} />;
};
